export default __webpack_public_path__ + "static/media/Copy.a1109e45.svg";